import { defineSseEvent } from '@terra/shared-sse-contracts';
import { TargetTypeSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';
import { TracePreviewSchema } from './trace.schema';

export const TraceSseEventTypeEnum = {
  TRACE_CREATED: 'TRACE_CREATED',
  TRACE_UPDATED: 'TRACE_UPDATED',
  TRACE_MESSAGE_ADDED: 'TRACE_MESSAGE_ADDED',
} as const;

export type TraceSseEventType =
  (typeof TraceSseEventTypeEnum)[keyof typeof TraceSseEventTypeEnum];

export const TraceCreatedPayloadSchema = z.object({
  traceId: z.string(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
  threadId: z.string(),
  trace: TracePreviewSchema,
});

export const TraceSseMessageSchema = z.looseObject({
  type: z.string(),
  data: z.looseObject({
    content: z.unknown(),
  }),
});

export type TraceSseMessage = z.infer<typeof TraceSseMessageSchema>;

export const TraceSseMessagesSchema = z.array(TraceSseMessageSchema);

export type TraceSseMessages = z.infer<typeof TraceSseMessagesSchema>;

export const TraceMessageAddedPayloadSchema = z.object({
  traceId: z.string(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
  threadId: z.string(),
  messages: TraceSseMessagesSchema,
});

export const TRACE_CREATED_SSE_EVENT = defineSseEvent({
  type: TraceSseEventTypeEnum.TRACE_CREATED,
  payload: TraceCreatedPayloadSchema,
  channelPrefix: 'trace',
  channelKey: ({ traceId }) => traceId,
  target: {
    type: ({ targetType }) => targetType,
    id: ({ targetId }) => targetId,
  },
});

export const TRACE_UPDATED_SSE_EVENT = defineSseEvent({
  type: TraceSseEventTypeEnum.TRACE_UPDATED,
  payload: TraceCreatedPayloadSchema,
  channelPrefix: 'trace',
  channelKey: ({ traceId }) => traceId,
  target: {
    type: ({ targetType }) => targetType,
    id: ({ targetId }) => targetId,
  },
});

export const TRACE_MESSAGE_ADDED_SSE_EVENT = defineSseEvent({
  type: TraceSseEventTypeEnum.TRACE_MESSAGE_ADDED,
  payload: TraceMessageAddedPayloadSchema,
  channelPrefix: 'trace',
  channelKey: ({ traceId }) => traceId,
  target: {
    type: ({ targetType }) => targetType,
    id: ({ targetId }) => targetId,
  },
});

export type TraceCreatedPayload = z.infer<typeof TraceCreatedPayloadSchema>;
export type TraceMessageAddedPayload = z.infer<
  typeof TraceMessageAddedPayloadSchema
>;
